import { create } from 'zustand';
import { Job, JobSearchParams, JobListParams } from '../types';
import { jobService } from '../services';

interface JobState {
  jobs: Job[];
  currentJob: Job | null;
  isLoading: boolean;
  error: string | null;
  searchResults: Job[];
  isSearching: boolean;
  
  // Actions
  fetchJobs: (params?: JobListParams) => Promise<void>;
  fetchJob: (id: number) => Promise<void>;
  searchJobs: (params: JobSearchParams) => Promise<void>;
  clearSearch: () => void;
  clearError: () => void;
  clearCurrentJob: () => void;
}

export const useJobStore = create<JobState>((set, get) => ({
  jobs: [],
  currentJob: null,
  isLoading: false,
  error: null,
  searchResults: [],
  isSearching: false,

  fetchJobs: async (params: JobListParams = {}) => {
    set({ isLoading: true, error: null });
    try {
      const jobs = await jobService.getJobs(params);
      set({ 
        jobs, 
        isLoading: false 
      });
    } catch (error: any) {
      set({ 
        error: error.detail || 'Failed to fetch jobs', 
        isLoading: false 
      });
    }
  },

  fetchJob: async (id: number) => {
    set({ isLoading: true, error: null });
    try {
      const job = await jobService.getJob(id);
      set({ 
        currentJob: job, 
        isLoading: false 
      });
    } catch (error: any) {
      set({ 
        error: error.detail || 'Failed to fetch job', 
        isLoading: false 
      });
    }
  },

  searchJobs: async (params: JobSearchParams) => {
    set({ isSearching: true, error: null });
    try {
      const searchResults = await jobService.searchJobs(params);
      set({ 
        searchResults, 
        isSearching: false 
      });
    } catch (error: any) {
      set({ 
        error: error.detail || 'Search failed', 
        isSearching: false 
      });
    }
  },

  clearSearch: () => {
    set({ searchResults: [], isSearching: false });
  },

  clearError: () => {
    set({ error: null });
  },

  clearCurrentJob: () => {
    set({ currentJob: null });
  },
}));